export default __webpack_public_path__ + "static/media/icon__8.c88cfbc1.svg";